/**
 * Utility functions for task components
 */

/**
 * Convert status to badge color
 */
export const getStatusColor = (status) => {
  switch (status) {
    case 'completed':
      return 'green';
    case 'pending':
      return 'yellow';
    case 'in_progress':
      return 'blue';
    case 'cancelled':
      return 'red';
    default:
      return 'gray';
  }
};

/**
 * Convert priority to badge color
 */
export const getPriorityColor = (priority) => {
  switch (priority) {
    case 'high':
      return 'red';
    case 'medium':
      return 'orange';
    case 'low':
      return 'green';
    default:
      return 'gray';
  }
};

/**
 * Format email by taking part before @
 */
export const formatUserEmail = (email) => {
  if (!email) return 'Unassigned';
  if (email.includes('@')) {
    return email.split('@')[0];
  }
  return email;
};

/**
 * Format a date in relative format (e.g., "2 days ago", "in 3 days")
 */
export const formatRelativeTime = (date) => {
  if (!date) return '';
  
  const now = new Date();
  const taskDate = new Date(date);
  const diffTime = taskDate - now;
  const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) {
    return 'Today';
  } else if (diffDays === 1) {
    return 'Tomorrow';
  } else if (diffDays === -1) {
    return 'Yesterday';
  } else if (diffDays > 0) {
    return `${diffDays} Days`;
  } else {
    return `${Math.abs(diffDays)} Days Ago`;
  }
};

/**
 * Format phone number for display
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return 'No phone';
  // If it's a +91 number, only show the number without country code
  if (phone.startsWith('+91')) {
    return phone.substring(3);
  }
  return phone;
};

/**
 * Group tasks by leadId
 */
export const groupTasksByLead = (tasks) => {
  const taskGroups = tasks.reduce((groups, task) => {
    if (!task.leadId) {
      // Handle tasks with no leadId
      if (!groups.noLead) groups.noLead = [];
      groups.noLead.push(task);
      return groups;
    }
    
    if (!groups[task.leadId]) groups[task.leadId] = [];
    groups[task.leadId].push(task);
    return groups;
  }, {});
  
  return taskGroups;
};

/**
 * Format task ID for display (last 6 characters)
 */
export const formatTaskId = (taskId) => {
  if (!taskId) return '';
  return taskId.substring(taskId.length - 6);
};
